module.exports = __webpack_public_path__ + "img/rocket-icon.9cf513e8.png";